import { APP_NAME,APP_TAGLINE } from '../branding.js'
import { BrandWordmark } from './BrandWordmark.js'

const FOOTER_LINKS: Array<{ label: string; href: string; external?: boolean }> = [
  { label: 'molecule.dev', href: 'https://www.molecule.dev', external: true },
  { label: 'Packages', href: 'https://www.molecule.dev/packages', external: true },
  { label: 'Privacy', href: 'https://www.molecule.dev/privacy', external: true },
  { label: 'Terms', href: 'https://www.molecule.dev/terms', external: true },
]

/**
 * Footer — the molecule.dev landing footer language: hairline top, gradient
 * wordmark + tagline on the left, link rail on the right, and the legal
 * attribution line. The © names the legal entity, Molecule Dev, Inc., per the
 * workspace convention for legal-attribution surfaces.
 */
export function Footer() {
  return (
    <footer className="mol-footer" data-mol-id="status-footer">
      <div
        style={{
          maxWidth: 1080,
          margin: '0 auto',
          padding: '28px 16px',
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: 20,
        }}
      >
        <div>
          <BrandWordmark size={18} molId="brand-wordmark-footer" />
          <div
            style={{
              marginTop: 6,
              fontSize: 12,
              color: 'var(--mol-color-text-secondary)',
            }}
          >
            {APP_TAGLINE}
          </div>
        </div>
        <nav
          style={{ display: 'flex', flexWrap: 'wrap', gap: 18, alignItems: 'center' }}
          aria-label={APP_NAME}
        >
          {FOOTER_LINKS.map((link) => (
            <a
              key={link.label}
              className="mol-footer-link"
              href={link.href}
              {...(link.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
            >
              {link.label}
            </a>
          ))}
        </nav>
      </div>
      <div
        style={{
          maxWidth: 1080,
          margin: '0 auto',
          padding: '0 16px 20px',
          fontSize: 12,
          color: 'var(--mol-color-text-tertiary)',
        }}
        data-mol-id="footer-legal-entity"
      >
        © 2026 Molecule Dev, Inc. · molecule.dev
      </div>
    </footer>
  )
}
